import { CheckIcon } from '@chakra-ui/icons';
import { CSSProperties, useMemo } from 'react';

import { CustomCheckboxInteface } from '../../core/models/inputs';

interface Props {
  id: string;
  name: string;
  info?: string;
  label?: React.ReactNode | string;
  invalidMessage?: string;
  input: CustomCheckboxInteface;
  style?: CSSProperties;
}

function CustomCheckbox({ id, name, info, label, invalidMessage, input, style }: Props) {
  const error = useMemo(
    () => (!input.showError ? '' : !input.isValid ? 'invalid' : ''),
    [input.showError, input.isValid],
  );

  return (
    <div style={style} className={`input input--checkbox${!error ? '' : ' error'}`}>
      {!label ? null : (
        <label className="input__checkbox-label" htmlFor={id}>
          {label}
          <input
            id={id}
            type="checkbox"
            name={name}
            checked={input.checked}
            onChange={input.onChange}
            className="input__checkbox"
            ref={input.ref}
          />
          {!input.checked ? null : (
            <CheckIcon className="input__checkmark-icon" width={5} height={5} />
          )}
          <span className="input__checkmark" />
        </label>
      )}
      {!info ? null : <div className="input__info caption">{info}</div>}
      {!error ? null : (
        <div className="input__error">
          <span>{error === 'invalid' ? invalidMessage : ''}</span>
        </div>
      )}
    </div>
  );
}

export default CustomCheckbox;
